import messageEvents from 'events/messages';
import computeUnreadMessageCount from 'actions/messages/computeUnreadMessageCount';
import sessionEvents from 'events/session';
import evaluateRules from 'actions/configuration/evaluateRules';

export default class MessageGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleError(err) {
    console.log('gateway encountered an error'); // eslint-disable-line no-console
    console.log(err); // eslint-disable-line no-console
  }

  handleFetchSuccess(payloads) {
    payloads.forEach(payload => this.context.executeAction(messageEvents.createOrUpdateMessageSuccess(payload)));
    this.context.executeAction(computeUnreadMessageCount);
  }

  handleFetchError() {
    console.log('fetch error'); // eslint-disable-line no-console
  }

  handleRequestNewSession() {
    this.context.executeAction(evaluateRules);
  }

  handleRequestSessionSuccess(payload) {
    this.context.executeAction(sessionEvents.sessionFetchSuccess(payload));
  }

  handleRequestSessionError() {
    this.context.executeAction(evaluateRules);
  }

  handleSendMessage(payload) {
    this.context.executeAction(messageEvents.createMessageSending(payload));
  }

  handleSendMessageSuccess(payload) {
    this.context.executeAction(messageEvents.createOrUpdateMessageSuccess(payload));
  }

  handleSendMessageError(id, errors) {
    this.context.executeAction(messageEvents.createOrUpdateMessageFailure(id, errors));
  }

  handleMessageReceived(payload) {
    this.context.executeAction(messageEvents.createOrUpdateMessageSuccess(payload));
    this.context.executeAction(computeUnreadMessageCount);
  }

  handleEntity(payload) {
    this.context.executeAction(messageEvents.createOrUpdateMessageSuccess(payload));
  }

  handleSessionCreated(sessionObj) {
    this.context.executeAction(sessionEvents.sessionCreateSuccess(sessionObj));
  }

  handleSessionUpdated(sessionObj) {
    this.context.executeAction(sessionEvents.sessionUpdateSuccess(sessionObj));
  }
}
